(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal', '$localStorage', '$q'];

    function PasswordController (Auth, Principal, $localStorage, $q) {
        var vm = this;
        vm.showPassword = false;
        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.togglePasswordVisibility = togglePasswordVisibility;


        Principal.identity().then(function(account) {
            vm.account = account;
        }, function (error) {
            // Ignore unhandled error
            return $q.reject(error);
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword || $localStorage.project === null) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        function togglePasswordVisibility(){
            vm.showPassword = !vm.showPassword;
        }
    }
})();
